export default __webpack_public_path__ + "static/media/image_atease.f74002f5.jpg";